import { TrashIcon } from 'BreetAssets';
import { Prompt } from 'BreetComponents';
import { handleApiError } from 'BreetHelpers';
import { closeModal, selectModals, useAppDispatch, useAppSelector, useDeleteBeneficiariesMutation } from 'BreetRedux';
import { useCallback } from 'react';

export const DialogDeleteBeneficiary = () => {
	const [deleteBeneficiaryAPI, { isLoading }] = useDeleteBeneficiariesMutation();

	const dispatch = useAppDispatch();

	const modals = useAppSelector(selectModals);

	const modal = modals.find((modalItem) => modalItem.id === 'deletebeneficiary');

	const beneficiaryData = modal?.metadata as { id?: string; isAutoSettlementBeneficiary?: boolean } | undefined;

	const closeDeleteModal = useCallback(() => {
		dispatch(closeModal('deletebeneficiary'));
	}, [dispatch]);

	const deleteBeneficiary = useCallback(() => {
		if (beneficiaryData?.id) {
			deleteBeneficiaryAPI(beneficiaryData.id).unwrap().then(closeDeleteModal).catch(handleApiError);
		}
	}, [beneficiaryData?.id, deleteBeneficiaryAPI, closeDeleteModal]);

	const title = beneficiaryData?.isAutoSettlementBeneficiary ? 'Delete Automatic Settlement Bank Account' : 'Delete Bank Account';

	const description = beneficiaryData?.isAutoSettlementBeneficiary
		? "The account you're about to delete is linked to your automatic settlement. It will be deactivated as well."
		: 'Are you sure you want to delete this account?';

	return (
		<Prompt
			title={title}
			description={description}
			cancelBtnText='Cancel'
			icon={<TrashIcon variant='secondary-outline' />}
			isLoading={isLoading}
			onCancel={closeDeleteModal}
			onProceed={deleteBeneficiary}
			proceedBtnText='Delete'
		/>
	);
};
